import { FileText } from 'react-feather'

export default [

  {
    id: 'audit_trail',
    title: 'Audit Trail',
    icon: <FileText />,
    navLink: '/activitylogs',
    resource: 'dashboard',
    beta: true
  }
]